define('app/components/play_template.element.view',[

    'lodash',

    'app.env',
    'app/config/constants',

    'app/helper/play.language',

    'app/components/ractivejs.se.decorator.play.dragndrop',

    'app/app.utils',

    'app/providers/sePlayPrv',
    'app/components/ractivejs.play',

    'toasties'

  ],
  function (
    _,
    ENV,
    CONSTANTS,
    language,
    DecoratorPlayDragndrop,
    UTILS,
    sePlayPrv,
    BaseView,
    Toasties
  ) {

    var LOG_LABEL = 'PLY ELM VIEW'

    var ElementView = BaseView.extend({
      // settings
      template: '#PlayElement-template',
      data: function () {
        return {
          ENV: ENV,
          CONST: CONSTANTS,
          $ui: null,

          elementCId: null,
          elementId: null,
          pageCId: null,
          elm: null,

          isOverScreen: false,
          fixMatrixHeader: false,
          elmTitleHeight: 0,
          elmTitlePaddingX: 0,
          elmMatrixHeaderHeight: 0,

          hasSpecialSetting: false,
          showedSpecialSettings: false,

          pages: null,
          experiments: null,

          hasChanges: false,

          errors: null,
          errorRenderingInlineScript: null,
          index: null,
          fieldPrefix: null
        }
      },

      // decorators & components
      decorators: {
        PlayDragndrop: DecoratorPlayDragndrop
      },

      // helper
      _getElement: function (elementCId) {
        var _this = this

        elementCId = elementCId || _this.get('elementCId')

        if (!elementCId) {
          console.error(LOG_LABEL, 'element cid missing!', _this)
          return
        }

        if (_this.elm && _this.elm.cid == elementCId) {
          return
        }

        _this.isUpdating = true

        var elmMdl = sePlayPrv.page.elements.get(elementCId)

        if (!elmMdl) {
          console.error(LOG_LABEL, 'element not found!', elementCId, sePlayPrv.page)
        }

        _this.elm = elmMdl

        _this.set('elm', elmMdl)

        elmMdl.on('hasChanged', function () {
          _this.update('elm')
          _this._renderElement()
        })

        _this.set('hasSpecialSetting', elmMdl.hasSpecialSetting())
        _this.set('options', elmMdl.getOptions())

        _this._getErrors()

        // wait for the read-in to have finished otherwise the observer
        setTimeout(function () {
          _this.isUpdating = false
        }, 5)

      },

      _getErrors: function () {
        var _this = this

        if (!_this.elm || !sePlayPrv.index) return

        var defaultErrorStrings = language.getErrorStrings(),
          elmErrors = _this.elm.pget('attr.validate.error')

        // translate error messages
        if (elmErrors && defaultErrorStrings) {
          var $errDom = $('<div>' + elmErrors + '</div>')

          $errDom.find('.se_item_error').each(function () {
            // format: <!-- div class="se_item_error">{{elm.error.errorText}}</div -->
            var errorText = $(this).text().trim()
            // is custom validation message ?

            if (defaultErrorStrings[errorText]) {
              $(this).html(defaultErrorStrings[errorText])
            }
          })

          elmErrors = $errDom.html()
        }

        _this.set('errors', elmErrors)
      },

      _evenCollsHeight: function () {
        var _this = this

        var $el = $(_this.el)

        var maxCellHeight = 0,
          $cells = $('.se_multicolumn_block > div', $el)

        var
          setCellHeight = function (isRetry) {

            maxCellHeight = 0
            $cells
              .css('height', 'auto')
              .each(function () {
                var $cell = $(this)

                var tmpHeight = $cell.height()

                if (maxCellHeight < tmpHeight) {
                  maxCellHeight = tmpHeight
                }
              })
              .each(function () {
                var $cell = $(this)
                if (maxCellHeight === 0) return
                $cell.css('height', maxCellHeight)
              })

            if (maxCellHeight === 0) {
              if (!isRetry) {
                isRetry = 1
              } else if (isRetry >= 10) {
                return // prevent endless loop; at this point we already waited 6 sec in total
              } else {
                isRetry += 1
              }
              // retry in a sec
              setTimeout(function () {
                setCellHeight(isRetry)
              }, 100 * isRetry)
            }
          }

        var resizeRunner,
          triggerResized = function () {
            clearTimeout(resizeRunner)
            resizeRunner = setTimeout(function () {
              $(window).trigger('resized')
            }, 500)
          },
          triggerSetCellHeight = function () {
            setCellHeight()
          }

        $(window)
          .on('resize', triggerResized)
          .on('resized', triggerSetCellHeight)

        _this._unrender_value.push(function () {
          $(window)
            .off('resize', triggerResized)
            .off('resized', triggerSetCellHeight)
        })

        setCellHeight()

      },

      _fixedTitleRow: function () {
        var _this = this

        if (typeof PLAY_FIXED_QUESTION_HEADERS === 'undefined' || !PLAY_FIXED_QUESTION_HEADERS) {
          return // disable if not explicitely enabled
        }

        var $elm = $(_this.el),
          $elmTitle = $elm.find('.se_question'),
          $elmMatrix = $elm.find('.se_matrix'),
          $elmMatrixHeader = $elmMatrix.find('.se_matrix_wide_header_row')

        function reset () {
          _this.set('isOverScreen', false)
          _this.set('elmTitleHeight', 0)
          _this.set('elmTitlePaddingX', 0)
          _this.set('fixMatrixHeader', false)
          _this.set('elmMatrixHeaderHeight', 0)
        }

        function updateIsOverScreen () {
          if ($elm.length === 0 ||
            $elmTitle.length === 0) return

          var isOverScreen = _this.get('isOverScreen'),
            elmHeight = $elm.height(),
            titleHeight = /* isOverScreen ? _this.get("elmTitleHeight") : */ ($elmTitle.height() + 24), // 24 = padding

            isFullscreen = !!$('#content-block').scrollTop(),

            scrollPos = isFullscreen ? $('#content-block').scrollTop() : $(document).scrollTop(), // content block is used as scroll container when in fullscreen
            elmPosTop = isFullscreen ? $elm.position().top : $elm.offset().top,
            elmPosBottom = elmPosTop + elmHeight,
            titlePosLeft = $elm.find('> div').offset().left,

            elmPosTopRel = elmPosTop - scrollPos,
            elmPosBottomRel = elmPosBottom - scrollPos,

            matrixHeaderOverScreen = false

          // check question element
          if (elmPosTopRel < 0 &&
            elmPosBottomRel > titleHeight + 10) { // 10 = some extra; 24 = padding

            isOverScreen = true

          } else {

            isOverScreen = false

          }

          // check matrix header
          if ($elmMatrixHeader.length) {
            var elmMatrixHeaderHeight = $elmMatrixHeader.height(),
              elmMatrixPos = isFullscreen ? $elmMatrix.position().top : $elmMatrix.offset().top,

              elmMatrixPosRel = elmMatrixPos - scrollPos

            if ((elmMatrixPosRel - titleHeight - 5) < 0 && isOverScreen) {
              matrixHeaderOverScreen = true
            }

          }

          _this.set('elmTitleHeight', titleHeight)
          _this.set('elmTitlePaddingX', titlePosLeft)
          _this.set('isOverScreen', isOverScreen)
          _this.set('fixMatrixHeader', matrixHeaderOverScreen)
          _this.set('elmMatrixHeaderHeight', elmMatrixHeaderHeight)
        }

        if ($elmTitle.size() === 0) {
          reset()
          return
        }

        $(window).on('scroll resize', updateIsOverScreen)
        $('#content-block').on('scroll', updateIsOverScreen)
        updateIsOverScreen()

        _this._unrender_value.push(function () {
          $(window).off('scroll resize', updateIsOverScreen)
          $('#content-block').off('scroll', updateIsOverScreen)
          reset()
        })

      },

      _inputOnClick: function () {
        var _this = this

        var $el = $(_this.el)

        var isProgressiveChoiceElement = $('[data-choice-mode]', $el).is('[data-choice-mode="progressive-choice"]'),
          $selected_rows = $('.se_multicolumn_block > div input[type=checkbox]:checked,' +
            '.se_multicolumn_block > div input[type=radio]:checked, ' +
            '.se_matrix > div input[type=checkbox]:checked,' +
            '.se_matrix > div input[type=radio]:checked', $el),
          $selectables = $('.se_multicolumn_block > div, .se_matrix .se_level_item:not(.se_level_item-text), .se_scenario .se_selectable', $el),
          $nottextinputelements = $('.se_multicolumn_block > div input:not([type=text]), .se_matrix > div input:not([type=text])', $el)

        $selected_rows.parentsUntil('div.se_level_item').parent('div').addClass('se_selected')
        $nottextinputelements.css('visibility', 'hidden')

        function setOnClickBehavior (ev) {

          var isScenario = $(ev.target).is('.se_selectable'),
            isInputText = $(ev.target).is('input[type=text]'),
            $inputNone = $(this).parent().find('input[data-option-none]'),

            $thisInput = $(this).find('input').first(),
            isOptionNone = $thisInput.is($inputNone),

            inputType = $thisInput.attr('type'),
            isChecked = $thisInput.attr('checked')

          switch (inputType) {
            case 'radio':

              if (isChecked) {
                // do not uncheck item

              } else {

                var $relRadioFields = $(this).closest('.se_item').find('input[type=radio][name="' + $thisInput.attr('name') + '"]'),
                  $inputgroup = $relRadioFields.map(function (i, elm) { return $(elm).closest('.se_selectable, .se_level_item') })

                // // find input group
                // while($inputgroup.find('input[type=radio][name="' + $thisInput.attr('name') + '"]').size() == 1 && $inputgroup.not(".se_item")){
                //     $inputgroup = $inputgroup.parent();
                // }

                // remove "selected" from all others
                $inputgroup
                  .filter(function (i, elm) { return $(elm).is('.se_selected') })
                  .each(function (i, elm) { $(elm).removeClass('se_selected') })

                $relRadioFields
                  .filter(function (i, elm) { return $(elm).is('input[checked]') })
                  .each(function (i, elm) {
                    $(elm).attr('checked', false)
                    elm.checked = false
                  })

                // check this item
                $thisInput.attr('checked', true)
                $thisInput[0].checked = true
                $(this)
                  .addClass('se_selected')

                $thisInput.trigger('change')
              }

              break
            case 'checkbox':

              if (isChecked && !isInputText) {
                // uncheck item

                $thisInput.attr('checked', false)
                $thisInput[0].checked = false
                $(this).removeClass('se_selected')

              } else {
                if (isOptionNone) {
                  // un-check all other options

                  $(this).parent().find('.se_selected').removeClass('se_selected')
                  $(this).parent().find('input[checked]').each(function (i, elm) {
                    $(elm).attr('checked', false)
                    elm.checked = false
                  })

                } else if ($inputNone.size()) {
                  // un-check "none"
                  $inputNone.closest('div.se_selected').removeClass('se_selected')
                  $inputNone.attr('checked', false)
                  $inputNone[0].checked = false
                }

                // check this item
                $thisInput.attr('checked', true)
                $thisInput[0].checked = true
                $(this).addClass('se_selected')
              }

              $thisInput.trigger('change')
              break
          }

        }

        $selectables.on('click', setOnClickBehavior)

        if (_this._unrender_value) {
          _this._unrender_value.push(function () {
            $selectables.off('click', setOnClickBehavior)
          })
        }

        if (isProgressiveChoiceElement) {
          _this._inputOnClickProgressiveChoiceMode()
        }
      },
      /**
       * _inputOnClickProgressiveChoiceMode
       *
       * "progressive choice" means, that an experiment is build like
       * a single-choice matrix in order to let the user choose a
       * specific order
       * based on the progressive choice mode like BESTWORST, FULL, SINGLE, CUSTOM
       * the backend creates the necessary input[type=radio] fields         *
       *
       * this function enhances the experiment DOM in order to only show the
       * current "choice" so that the user is not seeing a matrix
       * of multiple choice but only the current choice
       *
       * as the backend renders the experiment, the frontend does not "know"
       * anything about the choice mode but has to extract that information
       * generically based on the given amout of input fields and their nameing
       *
       * @private
       */
      _inputOnClickProgressiveChoiceMode: function () {
        var _this = this,
          $el = $(_this.el)

        // find alternatives

        var $alternatives = $('.alternative_item', $el),
          altCnt = $alternatives.length,
          $choiceLabels = $('.choice_labels', $el)

        $alternatives.addClass('se_selectable')

        setTimeout(function () {
          $alternatives.css('height', $alternatives.first().height())
          $alternatives.css('width', $alternatives.first().width())
          $choiceLabels.parent().css('min-height', Math.max.apply(Math.max, $choiceLabels.toArray().map(function (el) { return $(el).outerHeight() })))
        }, 500)

        // get option array
        var activeOption = 0,
          optionNames = [],
          optionPrefs = [],
          optionsObj = {},
          CHOICE_TYPES = CONSTANTS.EXPERIMENT.CHOICE_TYPES,
          choiceType = null

        // get all possible option names
        $el.find('input[type=radio]').each(function (i, elm) {
          var name = $(elm).attr('name'),
            prio = +name.match(/\d+$/)[0]

          if (!optionsObj[name]) {
            optionsObj[name] = []
            optionNames.push(name)
          }

          if(optionPrefs.indexOf(prio) === -1){
            optionPrefs.push(prio)
          }

          optionsObj[name].push($(elm).closest('.se_choice_element'))
        })

        // determine choice type based on circumstances
        if (optionNames.length === 1) {
          choiceType = CHOICE_TYPES.SINGLE
        } else if(optionPrefs.length === 2 && optionPrefs.indexOf(1) !== -1 && optionPrefs.indexOf(altCnt) !== -1) {
          choiceType = CHOICE_TYPES.BESTWORST
        }else if(optionPrefs.length === (altCnt - 1)){
          choiceType = CHOICE_TYPES.FULL
        } else {
          choiceType = CHOICE_TYPES.CUSTOM
        }

        // hide all but active option array
        function hideOtherOptions (optionIndex) {
          for (var i in optionsObj) {
            if (i === optionNames[optionIndex]) {
              $(optionsObj[i]).each(function (i, elm) { $(elm).show() })
            } else {
              $(optionsObj[i]).each(function (i, elm) { $(elm).hide() })
            }
          }

          $choiceLabels.hide()
          $choiceLabels.eq(optionIndex).show()
        }

        hideOtherOptions(activeOption)

        // hide selected alternatives and show next option array on selection

        function resetProgressiveChoice () {

          $('input[type=radio]', $el).each(function (i, elm) {
            elm.checked = false
            $(elm).closest('.se_selected').removeClass('se_selected')
          })

          $alternatives
            .addClass('se_selectable')
            .removeAttr('data-pref')
            .removeClass('se_selected')
            .css('visibility', 'visible')

          activeOption = 0
          hideOtherOptions(activeOption)
        }

        $('[data-task="reset-progressive-choice"]', $el).on('click', resetProgressiveChoice)

        function setProgressiveChoiceBehavior (ev) {
          // on click highlight selection
          var $elm = $(this),
            $altElm = $elm.closest('.alternative_item'),
            $choiceElm = $($('.se_choice_element', $elm)[activeOption])

          // ignore further clicks after last pref was selected
          if (activeOption >= optionNames.length) return

          // ignore click if this was already selected
          if ($altElm.hasClass('se_selected')) {
            return
          }
          $altElm.addClass('se_selected')

          // make sure visible input[radio] is selected
          $choiceElm
            .addClass('se_selected')
            .find('input[type=radio]')[0].checked = true

          // extract preference val from input name, e.g. "r##d4h2#pref2" -> 2
          var prefVal = +$elm.find('.se_choice_element.se_selected input[type=radio]').attr('name').match(/\d+$/)[0] || activeOption

          $altElm.attr('data-pref', prefVal + '.')

          // short timeout
          setTimeout(function () {
            activeOption++

            if (activeOption === optionNames.length) {
              var $notChosenAlts = $alternatives.not('.se_selected'),
                notChosenAltsLabel = ' - '

              if ($notChosenAlts.length === 1) {

                if (choiceType === CHOICE_TYPES.BESTWORST) {
                  notChosenAltsLabel = '2.'

                } else {
                  notChosenAltsLabel = $alternatives.length + '.'
                }
              }

              $notChosenAlts
                .attr('data-pref', notChosenAltsLabel)
                .removeClass('se_selectable')
                .addClass('se_selected')
            }

            // hide selected alternative
            // show next option row
            hideOtherOptions(activeOption)

          }, 150)
        }

        $alternatives.on('click', setProgressiveChoiceBehavior)

        if (_this._unrender_value) {
          _this._unrender_value.push(function () {
            $alternatives.off('click', setProgressiveChoiceBehavior)
          })
        }

      },

      _unrender_value: null, // (function(){ return []}()),
      _unrenderValue: function () {
        var _this = this,
          unrenderValueFn

        if (!_this._unrender_value)
          _this._unrender_value = []

        while (_this._unrender_value.length) {
          unrenderValueFn = _this._unrender_value.shift()
          unrenderValueFn()
        }
      },

      _renderValue: function () {
        // the value is normally the description

        // but also can contain a <script>-tag
        // -> this needs to be loaded after all elements of this page are rendered (in case it refers to another like hiding it)

        var _this = this

        _this._unrenderValue() // unrender previous value first.

        var renderingValue = $.Deferred()

        // Bad HACK -- disabling AMD detection by unsetting define.amd
        // improved against race-conditions when multiple elements with scripts are loaded on one page --ab
        var amdUnsetterId = Math.random() * Date.now()
        if (typeof define === 'function' && define.amd) {
          var oldDefineAmd = define.amd
          define.amd = false
          define._unsetAmd = oldDefineAmd
          define._amdUnset = 1

        } else if (define && define._amdUnset) {
          define._amdUnset += 1

        }
        renderingValue.always(function () {
          if (define && define._amdUnset !== undefined) {
            define._amdUnset -= 1

            if (define._amdUnset == 0) {
              var oldDefineAmd = define._unsetAmd
              define.amd = oldDefineAmd

              delete (define._amdUnset)
            }
          }
        })
        // Bad HACK END

        if (!_this.elm) {
          _this._getElement()
        }

        var $sdom = $('<div/>')

        function render (valPath, isRetry) {
          var val = _this.elm.get(valPath),
            valWrapNode = _this.find('.val_wrap'),
            rendering = $.Deferred(),
            hasError

          setTimeout(function () {

            $sdom.html(val)

            var scripts_inlineArr = $sdom.find('script').not('[src]').remove().toArray(), // extracting script source code
              scripts_refArr = $sdom.find('script').remove().toArray(),
              $styles = $sdom.find('style, link[href$=\'.css\']').remove()

            $styles.each(function (i, elm) {
              var styleNode

              if ($(elm).is('style')) {
                styleNode = UTILS.appendStyle(elm)
              } else {
                styleNode = UTILS.appendStyleFile(elm)
              }

              _this._unrender_value.push(function () {
                UTILS.removeNode(styleNode)
              })
            })

            function scriptError (err) {
              _this.set('errorRenderingInlineScript', err)

              console.warn(LOG_LABEL, 'Error rendering script', err, err.scriptRef)
              console.info(LOG_LABEL, '## Inline script errors' +
                '\n\n' +
                'This can be caused when AMD wrapped ' +
                'scripts are tried to be referenced via a global variable that is then missing.' +
                'Try to load such scripts not with a <script src=.../> but with the following approach:\n ' +
                '\n' +
                '<script>' +
                'require([\'https://uri/to/your/script.js\'], function (yourScript) { \n ' +
                '   window.yourScript = yourScript; // load it still into the global var \n ' +
                '   var ysObj = new yourScript(); // ... or use it right away \n ' +
                '}); \n' +
                '</script>')
            }

            UTILS.appendScripts(scripts_refArr, _this.el)
              .fail(function (err) {
                scriptError(err)

                renderingValue.resolve()
              })
              .done(function (newScriptNodes) {

                if (newScriptNodes && newScriptNodes.length) {
                  _this._unrender_value.push(function () {
                    newScriptNodes.forEach(function (newScriptNode) {
                      UTILS.removeNode(newScriptNode)
                    })
                  })
                }

                // hide empty attributes in experiments
                $sdom.find('.attribute:empty').hide()

                // hide new dom
                var domInvisibility = $sdom.css('visibility')
                if (domInvisibility !== 'hidden') {
                  domInvisible = true
                  $sdom.css('visibility', 'hidden')
                }

                // render new node content
                var origValWrapNode = valWrapNode
                $(valWrapNode).replaceWith($sdom)

                _this._unrender_value.push(function () {
                  $sdom.replaceWith(origValWrapNode)
                })

                _this.once('view.ready', function () {
                  UTILS.appendScripts(scripts_inlineArr, _this.el)
                    .fail(function (err) {
                      scriptError(err)
                    })
                    .done(function (newScriptNodes) {

                      if (newScriptNodes && newScriptNodes.length) {
                        _this._unrender_value.push(function () {
                          newScriptNodes.forEach(function (newScriptNode) {
                            UTILS.removeNode(newScriptNode)
                          })
                        })
                      }

                      // show new dom
                      $sdom.css('visibility', domInvisibility)

                      // you did it. all locked and loaded!

                    })
                    .always(function () {
                      setTimeout(function () {
                        rendering.resolve()
                        renderingValue.resolve()
                      }, 10)
                    })
                })

                setTimeout(function () {
                  if (!_this.get('status') || _this.get('status') < CONSTANTS.STATUS.LOADED)
                    _this.set('status', CONSTANTS.STATUS.LOADED)
                }, 10)

              })

          }, 5)

          return rendering.promise()
        }

        var _thisGroup = _this.elm.get('group'),
          _thisType = _this.elm.get('type')

        switch (_thisGroup) {
          case 'input': // the description (html)
          case 'input_array': // the description (html)
          case 'simple': // the content (js, html)

            // first set click handling and preset values
            _this._inputOnClick()
            _this._presetValuesFromSession()

            // then render any HTML, STYLE and SCRIPT parts.
            render('_value')

            break
          default:
            switch (_thisType) {
              case 'experiment': // the whole experiment (css, js, html)

                // first render experiment
                render('html').then(function () {

                  // then preset values and click-handling
                  _this._inputOnClick()
                  _this._presetValuesFromSession()

                  // add manual listener for input fields
                  function callOnChange (ev) {
                    var newVal = ev.target.value,
                      fieldName = ev.target.name

                    _this._onFieldChange({
                      newVal: newVal,
                      valName: fieldName
                    })
                  }

                  $('input.choice[type=radio]', _this.el).on('change', callOnChange)
                  _this._unrender_value.push(function () {
                    $('input.choice[type=radio]', _this.el).off('change', callOnChange)
                  })

                })

                break
              case 'close':
              default:
                // other elements

                _this.set('status', CONSTANTS.STATUS.LOADED)
                renderingValue.resolve()

                break

            }

            break
        }

        return renderingValue
      },

      _renderingElement: null,
      _renderElement: function () {
        var _this = this

        if (_this._renderingElement && !(_this._renderingElement.state() === 'resolved')) {
          if (!_this._renderingElement.hasQueue) {
            _this._renderingElement.hasQueue = true
            _this._renderingElement.then(function () {
              _this._renderingElement.hasQueue = false
              _this._renderElement()
            })
          }
          return
        }

        // preset _unrender_value
        _this._unrender_value = _this._unrender_value || []

        var _rendering = $.Deferred()
        _this._renderingElement = _rendering.promise()

        _this._renderValue().then(function () {

          setTimeout(function () {
            _this._evenCollsHeight()

            _this._fixedTitleRow()

          }, 15)

          _rendering.resolve()
          _this._renderingElement = null

          _this.set('status', CONSTANTS.STATUS.COMPLETE)

        })
      },

      _getSessionData: function (key) {
        var sessionData = sePlayPrv.page.get('sessionData')
        return key ? sessionData && sessionData[key] : sessionData
      },

      _sessionCache: function () {
        var _this = this,
          sessionId = _this._getSessionData('SESSION'),
          sessionCacheId = 'SE.PlaySession.' + sessionId

        function get (key) {
          if (!sessionId) { return key ? undefined : {} }

          var res
          try {
            res = sessionStorage.getItem(sessionCacheId) || '{}'
            res = JSON.parse(res)
          } catch (err) {
            console.log(LOG_LABEL, '_sessionCache', 'get', 'failed & reset', err, res)
            res = {}
            set({})
          }

          return key ? res[key] : res
        }

        function set (keyOrObj, val) {
          if (!sessionId) return

          var obj
          if (typeof keyOrObj === 'object') {
            obj = keyOrObj
            keyOrObj = null
            val = null

          } else if (typeof keyOrObj === 'string') {
            obj = get()
            if (val === undefined) {
              delete (obj[keyOrObj])
            } else {
              obj[keyOrObj] = val
            }

          } else {
            throw new Error([LOG_LABEL, '_sessionCache', 'set', 'wrong parameters', keyOrObj, val].join(','))
          }

          sessionStorage.setItem(sessionCacheId, JSON.stringify(obj))
        }

        return {
          get: get,
          set: set,
          setField: function (fieldName, val) {
            var fieldPrefix = _this.get('fieldPrefix') || '',
              valName = fieldName.substr(fieldPrefix.length)

            set(valName, val)
          }

        }
      },

      _presetValuesFromSession: function () {
        var _this = this

        var isExperiment = _this.elm.get('type') === 'experiment',
          $fields,
          cachedValues = _this._sessionCache().get()

        if (isExperiment) {

          $fields = $('input[type=radio]', _this.el)

          $fields.each(function (i, field) {
            if (field.checked || cachedValues && +cachedValues[field.name] === +field.value) {
              $(field).closest('.se_selectable').addClass('se_selected')
            }
          })

        } else {

          var values = _this._getSessionData(), // _this.get('values'),
            fieldPrefix = sePlayPrv.pget('header.fieldPrefix')

          _this.set('fieldPrefix', fieldPrefix).then(function () {

            $fields = $('*[name^="' + fieldPrefix + '"], *[data-name^="' + fieldPrefix + '"]', _this.el)

            $fields.each(function (i, field) {

              var $tmpField = $(field),
                fieldName = $tmpField.attr('name') || $tmpField.data('name'),
                valName = fieldName.substr(fieldPrefix.length),
                val = (values && values[valName]) || (cachedValues && cachedValues[valName])

              if (typeof val === 'undefined')
                return

              if ($tmpField.is('textarea, input[type=text]')) {
                $tmpField.val(val)

              } else if ($tmpField.is('input[type=radio]')) {
                $tmpField.filter('*[value="' + val + '"]').trigger('click')

              } else if ($tmpField.is('input[type=checkbox]')) {

                if (+val === 1 && +cachedValues[valName] === 2) {
                  val = 2
                }

                if ($tmpField.attr('value') == val) {
                  $tmpField.trigger('click')
                }

              } else if ($tmpField.is('select:not([multiple])')) {
                $tmpField.find('option[value="' + val + '"]').attr('selected', true)

              } else if ($tmpField.is('option') && $tmpField.attr('data-value') == val) {
                $tmpField[0].selected = true
              }

            })

          })

        }

      },

      _onFieldChange: function (event) {
        var _this = this
        if (_this.isUpdating || !_this.elm) return

        var newVal = event.newVal,
          oldVal = event.oldVal,
          fieldName = event.valName

        if (newVal === oldVal) return

        _this._sessionCache().setField(fieldName, newVal)

        console.log(LOG_LABEL, 'CHANGE', fieldName, newVal, oldVal)
      },

      // actions

      // events

      oninit: function () {
        var _this = this

        // set index
        _this.set('index', sePlayPrv.index)

        // init teardown stack
        _this._teardown = []

        _this._getElement()

      },

      onrender: function () {
        var _this = this

      },
      oninsert: function () {
        var _this = this

        // init detach stack
        _this._detach = []
        _this._detach.push(function () {
          _this._unrenderValue()
          _this.off('field-change', _this._onFieldChange)
        })

        _this._renderElement()

        // set custom events
        _this.on('field-change', _this._onFieldChange)
        // this should happen after insert

      },

      _detach: [],
      ondetach: function () {
        var _this = this
        _.each(_this._detach, function (detachFn) {
          detachFn()
        })
        _this._detach = []
      },

      oncomplete: function () {
        var _this = this

      },

      _teardown: [],
      onteardown: function () {
        var _this = this

        _this.ondetach()

        _.each(_this._teardown, function (teardownFn) {
          teardownFn()
        })
      }

    })

    return ElementView

  })


;
